<template>
  <div class="d-flex flex-column align-center">
    <div class="d-flex flex-column">
    <p class="title-page">Upload de Layout XML</p>
    <v-card class="elevation-1" width="800px">
      <v-form ref="formXml">
        <v-row class="pa-8">
          <v-col class="d-flex" cols="12">
            <v-text-field
              label="Nome do layout"
              :rules="[rules.required]"
              v-model="itemsForms.nameLayout"
            ></v-text-field>
          </v-col>
          <v-col class="d-flex" cols="12">
            <v-text-field
              v-model="itemsForms.class"
              :rules="[rules.required]"
              label="Classe"
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-file-input
              counter
              chips
              multiple
              :rules="[rules.required]"
              accept=".xml"
              label="Notas"
              v-model="itemsForms.notas"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-form>
      <div class="d-flex align-center justify-end mr-8">
        <v-btn color="primary" @click="save">SALVAR</v-btn>
      </div>
      <br />
    </v-card>
    <ModalInfo :response="responseList" :dialog="dialog" @upload="closeModal" />
  </div>
  </div>
</template>

<script>
import toast from "@/commom/toast";
import LayoutXml from "@/services/http/rpa/uploadLayoutXml";
import ModalInfo from "../components/modalInfo.vue";
export default {
  components: {
    ModalInfo,
  },
  data() {
    return {
      itemsForms: {
        nameLayout: "",
        class: "",
        notas: [],
      },
      rules: {
        required: (value) => !!value || "Campo obrigatório.",
      },
      responseList: [],
      dialog: false,
    };
  },

  methods: {
    async save() {
      let res;
      let info = "";
      if (this.$refs.formXml.validate()) {
        let formData = new FormData();
        formData.append("class", this.itemsForms.class);
        formData.append("nameLayout", this.itemsForms.nameLayout);
        for (let item in this.itemsForms.notas) {
          formData.append("notas[]", this.itemsForms.notas[item]);
        }
        try {
          res = await LayoutXml().store(formData);
          toast("success", "Layout carregado com sucesso");
          for (let item in res.data) {
            info += `filename: ${res.data[item].filename}`;
          }
          this.dialog = true;
          this.responseList = res.data;
        } catch (e) {
          toast("error", e.message);
          console.log(e);
        }
      }
    },
    closeModal() {
      this.dialog = false;
      this.$refs.formXml.reset();
    },
  },
};
</script>
